/** @format */

import React, { useState, useEffect, useRef } from "react";
import SecureStorage from "react-secure-storage";

import Water_level1 from "../assets/Water_level1.png";
import Water_level2 from "../assets/Water_level2.png";
import Water_level3 from "../assets/Water_level3.png";
import Water_level4 from "../assets/Water_level4.png";
import Water_level5 from "../assets/Water_level5.png";

const constants = require("file-configs/constants");

export const getDataDropdownProblemType = async () => {
  const options = [
    { id: 1, name: "อื่นๆ" },
    { id: 2, name: "ไฟฟ้า" },
    { id: 3, name: "น้ำท่วม" },
  ];

  return options;
};

export const getDataDropdownWaterLevel = async (lan) => {
  let options = [];
  if (lan != "ENG") {
    options = [
      { level: 1, name: "ระดับข้อเท้า", photo: Water_level1 },
      { level: 2, name: "ระดับเข่า", photo: Water_level2 },
      { level: 3, name: "ระดับเอว", photo: Water_level3 },
      { level: 4, name: "ระดับเหนือเอว", photo: Water_level4 },
      { level: 5, name: "ระดับคาง", photo: Water_level5 },
    ];
  } else {
    options = [
      { level: 1, name: "Ankle", photo: Water_level1 },
      { level: 2, name: "Knee", photo: Water_level2 },
      { level: 3, name: "Waist", photo: Water_level3 },
      { level: 4, name: "Above waist", photo: Water_level4 },
      { level: 5, name: "Chin", photo: Water_level5 },
    ];
  }

  return options;
};

export const getDataDropdownTimeFlood = async (lan) => {
  let options = [];
  if (lan != "ENG") {
    options = [
      { level: 1, name: "ท่วมน้อยกว่า 1 ชั่วโมง" },
      { level: 2, name: "ท่วมน้อยกว่า 3 ชั่วโมง" },
      { level: 3, name: "ท่วมน้อยกว่า 1 วัน" },
      { level: 4, name: "ท่วมน้อยกว่า 1 อาทิตย์" },
      { level: 5, name: "ท่วมมากกว่า 1 อาทิตย์" },
    ];
  } else {
    options = [
      { level: 1, name: "Flooded for 1 hour." },
      { level: 2, name: "Flooded for 3 hours." },
      { level: 3, name: "Flooded for 1 day." },
      { level: 4, name: "Flooded for 1 week." },
      { level: 5, name: "Flooded for more than 1 week." },
    ];
  }

  return options;
};
export const getOrg = async (lat, lon, lang) => {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
        Authorization:
          `Bearer ${process.env.REACT_APP_TRAFFY_TOKEN}`,
      },
      body: JSON.stringify({
        lat: lat,
        lon: lon,
        lang: lang,
        privacy: "all",
        show_in_chatbot: true,
      }),
    };

    const response = await fetch(
      constants.APITRAFFY + "/org/responsible_org/?limit=5000&lang=" + lang,
      requestOptions,
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        "getOrg error:",
        response.status,
        response.statusText,
        errorText,
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("getOrg fetch failed:", error);
    throw error; // เผื่อให้ caller handle ต่อ
  }
};

export const getProblemType = async (idOrg_selected, lang) => {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
        // Authorization:
        //   "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxNDIzNDA2LCJ1c2VybmFtZSI6InRvdXJpc3QiLCJleHAiOjE4NTkyNTcxMDAsImVtYWlsIjoidG91cmlzdEBnbWFpbC5jb20iLCJvcmlnX2lhdCI6MTc2NDY0OTEwMCwiZXhjaGFuZ2Vfa2V5IjoiNDkzZGIxZTE2Y2ZmNDI1MTc3YzliMGIxNWRmOWYzODNmMmU0YTQwYWU1ZDhjYWY2YWE4NjUzZWZkMDA2MjNkOCIsInRva2VuX2lkIjoyNCwiZXhwaXJlX3RpbWVzdGFtcCI6MTg1OTI1NzEwMH0.ZWCJwGhQB56pKmksB0IKPHzwOZ6S7dI935X0Wu1dgPI",
      },
    };

    let response = await fetch(
      constants.APITRAFFY +
        "/org/fondue-problem-custom/?limit=1000&fondue_group=" +
        idOrg_selected +
        "&lang=" +
        lang +
        "&sort_by=name",
      requestOptions,
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        "getProblemType error:",
        response.status,
        response.statusText,
        errorText,
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    let data = await response.json();

    return data;
  } catch (error) {
    console.error("getProblemType fetch failed:", error);
    throw error; // เผื่อให้ caller handle ต่อ
  }
};

export const checkCasePassword = async (ticket, password, lang) => {
  const authorization = await SecureStorage.getItem("authorization");

  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
      },
    };

    // /fondue-cases-api/get_case/
    let response = await fetch(
      constants.APITRAFFY +
        "/fondue-cases-api/get_case/?ticket_id=" +
        ticket +
        "&p=" +
        password +
        "&lang=" +
        lang,
      requestOptions,
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        "checkCasePassword error:",
        response.status,
        response.statusText,
        errorText,
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    let data = await response.json();

    return data;
  } catch (error) {
    console.error("checkCasePassword fetch failed:", error);
    throw error; // เผื่อให้ caller handle ต่อ
  }
};

export const sendData = async (
  description,
  problem_type,
  photo,
  lat,
  lng,
  org_id,
  lang,
) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Device-Types": constants.DEVICE_TYPE,
      "App-Version": constants.WEB_VERSION,
      Authorization:
        `Bearer ${process.env.REACT_APP_TRAFFY_TOKEN}`,
    },
    body: JSON.stringify({
      description: description,
      topic_name: problem_type["name"],
      photo_base64: [photo],
      latitude: lat,
      longitude: lng,
      org_id: org_id.id,
      lang: lang,
    }),
  };

  let response = await fetch(
    "https://publicapi.traffy.in.th/exchange-api/new-issue/v1",
    requestOptions,
  );

  let data = await response.json();
  // console.log('data',data);

  return data;
};

export const sendDataEN = async (description, photo, lat, lng, lang) => {
  // Function to get the size of the base64-encoded photo
  const getPhotoSize = (base64String) => {
    // Remove base64 metadata if present (e.g., data:image/jpeg;base64,)
    const cleanedBase64 = base64String.split(",")[1] || base64String;
    const sizeInBytes = cleanedBase64.length * (3 / 4); // Calculate the size in bytes
    const sizeInKB = sizeInBytes / 1024; // Convert to KB
    return sizeInKB.toFixed(2); // Return size in KB rounded to 2 decimal places
  };

  const photoSize = getPhotoSize(photo);

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Device-Types": constants.DEVICE_TYPE,
      "App-Version": constants.WEB_VERSION,
      Authorization:
        `Bearer ${process.env.REACT_APP_TRAFFY_TOKEN}`,
    },
    body: JSON.stringify({
      description: description,
      latitude: lat,
      longitude: lng,
      lang: lang,
      photo_base64: [photo],
      org_id: 19768,
    }),
  };

  let response = await fetch(
    "https://publicapi.traffy.in.th/exchange-api/new-issue/v1",
    requestOptions,
  );

  let data = await response.json();

  // Alert the response data

  return data;
};

export const getIpAddress = async () => {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
      },
    };

    let response = await fetch(
      "https://kong.traffy.in.th/fondue-api-php/get_ip/",
      requestOptions,
    );

    let data = await response.json();

    return data;
  } catch (error) {
    console.error("getIpAddress fetch failed:", error);
    throw error; // เผื่อให้ caller handle ต่อ
  }
};

export const getPhotoAnalyzer = async (imgBase64, lang) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Device-Types": constants.DEVICE_TYPE,
      "App-Version": constants.WEB_VERSION,
      Authorization:
        `Bearer ${process.env.REACT_APP_TRAFFY_TOKEN}`,
    },
    body: JSON.stringify({
      photo_base64: imgBase64,
      lang: lang,
    }),
  };

  let response = await fetch(
    "https://kong.traffy.in.th/gemini-api/photo_analyzer/v1",
    requestOptions,
  );

  let data = await response.json();

  return data;
};
